import { makeActionCreator } from "@ec-oem/ec.oem.oa3.ui.core/utility";

export const INITIALIZE_APP = "actions/INITIALIZE_APP";
export const initializeApp = makeActionCreator(INITIALIZE_APP, false);
export const SET_HOSTS = "actions/SET_HOSTS";
export const setHosts = makeActionCreator(SET_HOSTS, false, "hosts");
